export const CATALOG_CATEGORIES = [
    { code: 'cleaning', label: 'Limpieza', defaultColor: '#26C6DA', svgFile: '0.svg' },
    { code: 'tech', label: 'Tecnología', defaultColor: '#42A5F5', svgFile: '1.svg' },
    { code: 'food', label: 'Alimentos', defaultColor: '#FFA726', svgFile: '2.svg' },
    { code: 'gift', label: 'Regalos', defaultColor: '#EF5350', svgFile: '3.svg' },
    { code: 'scholar', label: 'Escolar / Útiles', defaultColor: '#66BB6A', svgFile: '4.svg' },
    { code: 'books', label: 'Libros', defaultColor: '#8D6E63', svgFile: '5.svg' },
    { code: 'phones', label: 'Teléfonos / Apple', defaultColor: '#78909C', svgFile: '6.svg' },
    { code: 'audio', label: 'Audio / Audífonos', defaultColor: '#AB47BC', svgFile: '7.svg' },
    { code: 'room', label: 'Hogar / Habitación', defaultColor: '#795548', svgFile: '8.svg' },
    { code: 'sport', label: 'Deportes', defaultColor: '#29B6F6', svgFile: '9.svg' },
    { code: 'eco', label: 'Ecológico / EcoFriendly', defaultColor: '#4CAF50', svgFile: '10.svg' },
    { code: 'party', label: 'Fiestas', defaultColor: '#FF7043', svgFile: '11.svg' },
    { code: 'flowers', label: 'Flores', defaultColor: '#EC407A', svgFile: '12.svg' },
    { code: 'tools', label: 'Herramientas', defaultColor: '#607D8B', svgFile: '13.svg' },
    { code: 'music', label: 'Instrumentos / Música', defaultColor: '#7E57C2', svgFile: '14.svg' },
    { code: 'drugs', label: 'Salud / Farmacia', defaultColor: '#EF5350', svgFile: '15.svg' },
    { code: 'bakery', label: 'Repostería / Pasteles', defaultColor: '#FFCA28', svgFile: '16.svg' },
    { code: 'plastic', label: 'Plásticos', defaultColor: '#26A69A', svgFile: '17.svg' },
    { code: 'cloth', label: 'Ropa / Moda', defaultColor: '#EC407A', svgFile: '18.svg' },
    { code: 'fruits', label: 'Frutas y Verduras', defaultColor: '#9CCC65', svgFile: '19.svg' },
    { code: 'wine', label: 'Vinos y Licores', defaultColor: '#8D6E63', svgFile: '20.svg' },
    { code: 'candy', label: 'Dulces / Golosinas', defaultColor: '#FF7043', svgFile: '21.svg' },
    { code: 'shoes', label: 'Zapatos / Calzado', defaultColor: '#5C6BC0', svgFile: '22.svg' },
    { code: 'jewelry', label: 'Joyería y Accesorios', defaultColor: '#FFD54F', svgFile: '23.svg' },
    { code: 'photo', label: 'Fotografía / Cámaras', defaultColor: '#78909C', svgFile: '24.svg' },
    { code: 'homeAppliances', label: 'Electrodomésticos', defaultColor: '#42A5F5', svgFile: '25.svg' },
    { code: 'other', label: 'Otro / General', defaultColor: '#607D8B', svgFile: '26.svg' }
];

export const getCategoryByCode = (code) => {
    return CATALOG_CATEGORIES.find(c => c.code === code) || CATALOG_CATEGORIES.find(c => c.code === 'other');
};

export const getCategorySvgUrl = (code) => {
    const cat = getCategoryByCode(code);
    return `/assets/categories/${cat.svgFile}`;
};
